import { Controller } from "stimulus"

export default class extends Controller {
  setTxnType() {
    let txn_type = this.element.dataset.id
    let downloadButton = $('[data-id="download-txns"]')
    let url =  new URL(downloadButton[0]?.href)
    url.searchParams.set("txn_type", txn_type)
    downloadButton[0].setAttribute('href', url.href)
    if (txn_type == 'expense') {
      $('[data-id="expense"]').addClass('is-success is-selected')
      $('[data-id="sales"]').removeClass('is-success is-selected')
     } else {
      $('[data-id="sales"]').addClass('is-success is-selected')
      $('[data-id="expense"]').removeClass('is-success is-selected')
    }
  }
}